import { createApp } from 'vue';
import App from './components/App.vue';
import { store } from './store';
import {
  router,
  checkAuthGuard,
} from './router';
import "./sass/app.scss";
import { http } from '@/providers/http.js';
import './interceptors/axios.js';
import * as Sentry from '@sentry/capacitor';
import * as SentryVue from '@sentry/vue';

http.mount();

checkAuthGuard();

const app = createApp(App);
Sentry.init({
    app,
    dsn: "https://4bad4efcfa8f5d45662ae8cae64639a4@o4509051467988992.ingest.de.sentry.io/4509051634974800",
    integrations: [],
  }, // Forward the init method from @sentry/vue
  SentryVue.init,
);
// Dynamically import components

const components = import.meta.glob('./components/**/*.vue');
for (const path in components) {
  components[path]().then((module) => {
    const componentName = path.split('/').pop().replace(/\.\w+$/, '');
    app.component(componentName, module.default);
  });

}
app.use(router);

app.use(store);

app.mount('#app');
